import { Icon } from "../../../components/BaseComponents/Icon";

export const HeaderPhoneIcon = (props) => (
	<Icon viewBox="0 0 48 48" fill="none" {...props}>
		<circle cx="24" cy="24" r="24" fill="currentColor" />
		<path
			fill="#fff"
			fillRule="evenodd"
			d="M25.3 12.3a1 1 0 0 1 .7-.3 10.01 10.01 0 0 1 10 10 1 1 0 0 1-2 0 8 8 0 0 0-8-8 1 1 0 0 1-.7-1.7Zm7.9 17.38-5.59-2.4a1 1 0 0 0-1.1.2l-2.33 2.3a18.96 18.96 0 0 1-3.38-2.58 19.15 19.15 0 0 1-2.59-3.37l2.3-2.33a1 1 0 0 0 .21-1.1l-2.4-5.59a1 1 0 0 0-1.17-.57l-4.4 1.16a1 1 0 0 0-.75 1c.28 5.11 2.4 9.95 5.99 13.62 3.66 3.58 8.5 5.7 13.62 5.98a1 1 0 0 0 1-.75l1.16-4.4a1 1 0 0 0-.57-1.17ZM30 22a1 1 0 0 0 2 0 6 6 0 0 0-6-6 1 1 0 0 0 0 2 4 4 0 0 1 4 4Z"
			clipRule="evenodd"
		/>
	</Icon>
);
